module.exports = __webpack_public_path__ + "static/media/maleSuggestion2.3d6eb18b.jpg";